// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormControl} from "@angular/forms";
import {zoomInOnEnterAnimation} from "angular-animations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_DatePickerDialogInput extends MatDialogDataBaseInput {
	title: string;
	startDate?: Date | string;
	endDate?: Date | string;
}

export interface DialogData_DatePickerDialogOutput extends MatDialogDataBaseOutput {
	startDate?: Date;
	endDate?: Date;
}

@Component({
	selector: "sim-date-picker-dialog",
	templateUrl: "./date-picker-dialog.component.html",
	styleUrls: ["./date-picker-dialog.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175})],
	standalone: false,
})
export class DatePickerDialogComponent extends BasicMaterialDialog<
	DatePickerDialogComponent,
	DialogData_DatePickerDialogInput,
	DialogData_DatePickerDialogOutput
> {
	startFormControl = new FormControl<Date>(null);
	endFormControl = new FormControl<Date>(null);

	nowDate: Date = new Date();

	constructor(_injector: Injector) {
		super(_injector);

		if (this.data?.startDate) {
			this.startFormControl.setValue(new Date(this.data.startDate));
		}

		if (this.data?.endDate) {
			this.endFormControl.setValue(new Date(this.data.endDate));
		}
	}

	ok() {
		this.close({
			action: "ok",
			endDate: this.endFormControl.value,
			startDate: this.startFormControl.value,
		});
	}
}
